import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class CatalogReferenceModel {
  constructor(catalogReferenceModel) {
    _defineProperty(this, "catalogItemId", void 0);
    this.catalogItemId = catalogReferenceModel.catalogItemId;
  }
  static fromV2(catalogReference) {
    return new CatalogReferenceModel({
      catalogItemId: catalogReference == null ? void 0 : catalogReference.catalogItemId
    });
  }

  /* eslint-disable-next-line sonarjs/no-identical-functions */
  static fromV1(catalogReference) {
    return new CatalogReferenceModel({
      catalogItemId: catalogReference == null ? void 0 : catalogReference.catalogItemId
    });
  }
}
//# sourceMappingURL=CatalogReference.model.js.map